import { useSiteContext, useTranslation } from '@eti/providers';
import { Inline, Text } from '@etg/wings';
import { UploadSimple } from '@phosphor-icons/react';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';

const UploadDocumentsLink = () => {
  const { t } = useTranslation();
  const { language } = useSiteContext();
  const { oldOrderNumber } = useOrderDetails();
  return (
    <a
      aria-label={`${t('CheckIn.Purchased.UploadDocs.Link.Text')}, ${t(
        'ScreenReader.Link.OpensInNewTab.AriaLabel.Text',
      )}`}
      href={`https://console.passnfly.com/checkin/activate/${oldOrderNumber}?language=${
        language?.code ?? 'en'
      }`}
      rel="noreferrer"
      target="_blank"
    >
      <Inline alignY="center" spacing={0}>
        <UploadSimple aria-hidden size={24} />
        <Text>{t('CheckIn.Purchased.UploadDocs.Link.Text')}</Text>
      </Inline>
    </a>
  );
};

export default UploadDocumentsLink;
